module.exports = __webpack_public_path__ + "quotezone-ui/img/FishermanRodToy.98b30111.png";